let resolveFn = null;

export function waitForWcpmReveal() {
  return new Promise((resolve) => {
    resolveFn = resolve;
  });
}

export function resolveWcpmReveal() {
  const r = resolveFn;
  resolveFn = null;
  r?.();
}
